<div class="dialog-content">
  <img
    class="photo"
    alt="photo"
    [src]="media.url"
    *ngIf="media.type === 'photo'"
  />

  <video
    controls
    (click)="toggleVideo()"
    #videoPlayer
    *ngIf="media.type === 'video'"
    alt="video"
    autoplay
    loop
  >
    <track label="English" kind="captions" srclang="en" default />
    <track label="Arabic" kind="captions" srclang="ar" />
    <source [src]="media.url" type="video/mp4" />
    Your browser does not support HTML5 video.
  </video>

  <div class="video-feed-container" *ngIf="media.type === 'stream'">
    <div
      class="video-control-bar"
      *ngIf="isPlayableCameraStream && streamEngineServerUrl"
    >
      <i
        class="fa ctrl-icon"
        [class.fa-volume-off]="playerUi.muted"
        [class.fa-volume-up]="!playerUi.muted"
        aria-hidden="true"
        (click)="toggleMuted($event)"
        [title]="
          (playerUi.muted ? 'VIDEO_CONTROL.UNMUTE' : 'VIDEO_CONTROL.MUTE')
            | translate
        "
      ></i>
      <i
        class="fa ctrl-icon"
        [class.fa-compress]="playerUi.objectFit === 'fill'"
        [class.fa-expand]="playerUi.objectFit === 'contain'"
        aria-hidden="true"
        (click)="toggleObjectFit($event)"
        [title]="
          (playerUi.objectFit === 'fill'
            ? 'VIDEO_CONTROL.FIT_CONTAIN'
            : 'VIDEO_CONTROL.FIT_FILL'
          ) | translate
        "
      ></i>
    </div>
    <div class="stream-player">
      <rse-player
        *ngIf="
          isPlayableCameraStream && streamEngineServerUrl;
          else streamIframe
        "
        [serverUrl]="streamEngineServerUrl"
        [url]="media.url"
        [appToken]="streamAppToken"
        [muted]="playerUi.muted"
        [objectFit]="playerUi.objectFit"
        [showLoadingOverlay]="true"
      ></rse-player>
      <ng-template #streamIframe>
        <iframe
          width="100%"
          height="100%"
          frameBorder="0"
          [src]="media.url | safe"
        ></iframe>
      </ng-template>
    </div>
  </div>

  <nb-icon
    nbPrefix
    icon="close-outline"
    pack="eva"
    class="close-dialog"
    (click)="closeDialog()"
  >
  </nb-icon>
</div>
